"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListingApprovalStatus;
(function (ListingApprovalStatus) {
    ListingApprovalStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ListingApprovalStatus["PENDING"] = "PENDING";
    ListingApprovalStatus["APPROVED_ORG"] = "APPROVED_ORG";
    ListingApprovalStatus["APPROVED"] = "APPROVED";
    ListingApprovalStatus["REJECTED"] = "REJECTED";
    ListingApprovalStatus["DELETED"] = "DELETED";
    ListingApprovalStatus["PENDING_DELETION"] = "PENDING_DELETION";
})(ListingApprovalStatus || (ListingApprovalStatus = {}));
exports.ListingApprovalStatus = ListingApprovalStatus;
